import React from 'react';
import FlipButton from './FlipButton';
import BoxComponent from './BoxComponent';

const BoxesSection = ({
  isFlipped,
  setIsFlipped,
  handleVerticalFlip,
  leftBoxItems,
  rightBoxItems,
  isRotatedBox,
  setIsRotatedBox,
  checkedItems,
  handleCheckboxChange,
  leftBoxConveyorStyle,
  rightBoxConveyorStyle,
  generateConveyorFilename,
  isReversed,
  flippedBoxes,
  handleBoxItemsChange,
  handleCheckedItemsChange,
  setActiveBox,
  motorSelections,
  taSelections,
  filenameFlipStates,
  stkSelections,
  globalImageCache,
  setGlobalImageCache,
  leftBoxCacheClear,
  rightBoxCacheClear,
  getImageForSelection,
  getImageKey,
  motorVariantImageUrls,
  taImageUrls,
  stkImageUrls,
  handleMotorSelect,
  motorVariantByBox,
  sawImage,
  selectedSaw,
  handleDeletePortion,
  infeedRef,
  outfeedRef,
  sampleData,
  setSampleData,
  isGeneratingPdf,
  sawRef,
  handleSTKChange,
  stkVariantByPortion,
  handleTAChange,
  taVariantByPortion
}) => {
  return (
    <div className="flex justify-center items-center gap-1 relative quote-boxes-exclude">
      <FlipButton position="left" onClick={() => handleVerticalFlip('left')} isFlipped={isFlipped} setIsFlipped={setIsFlipped} />

      <div id="infeed-modules" ref={infeedRef} className="contents">
      <BoxComponent
        isGeneratingPdf={isGeneratingPdf}
        boxItems={leftBoxItems}
        boxName="left"
        isRotatedBox={isRotatedBox}
        setIsRotatedBox={setIsRotatedBox}
        checkedItems={checkedItems.left}
        handleCheckboxChange={handleCheckboxChange}
        conveyorStyle={leftBoxConveyorStyle}
        generateConveyorFilename={generateConveyorFilename}
        isReversed={isReversed}
        isFlippedVertically={flippedBoxes.left}
        onBoxItemsChange={handleBoxItemsChange}
        onCheckedItemsChange={handleCheckedItemsChange}
        setActiveBox={setActiveBox}
        motorSelections={motorSelections}
        taSelections={taSelections}
        filenameFlipStates={filenameFlipStates}
        stkSelections={stkSelections}
        globalImageCache={globalImageCache}
        setGlobalImageCache={setGlobalImageCache}
        cacheClearTrigger={leftBoxCacheClear}
        getImageForSelection={getImageForSelection}
        getImageKey={getImageKey}
        leftBoxConveyorStyle={leftBoxConveyorStyle}
        rightBoxConveyorStyle={rightBoxConveyorStyle}
        motorImageUrls={{ left: motorVariantImageUrls.left, right: motorVariantImageUrls.right }}
        taImageUrls={{ left: taImageUrls.left, right: taImageUrls.right }}
        stkImageUrls={{ left: stkImageUrls.left, right: stkImageUrls.right }}
        onMotorSelect={handleMotorSelect}
        motorVariantByBox={motorVariantByBox}
        onDeletePortion={handleDeletePortion}
        sampleData={sampleData}
        setSampleData={setSampleData}
        handleSTKChange={handleSTKChange}
        stkVariantByPortion={stkVariantByPortion}
        handleTAChange={handleTAChange}
        taVariantByPortion={taVariantByPortion}
      />
      </div>

      <div id="saw-module" ref={sawRef} style={{ width: '5rem', height: isGeneratingPdf ? '12rem' : '31.25rem', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: isGeneratingPdf ? '0' : '-1.5rem', transform: isGeneratingPdf ? 'translateY(18px)' : (selectedSaw?.image_name?.toLowerCase().includes('static') ? 'translateY(0px)' : ((flippedBoxes.left || flippedBoxes.right) ? 'translateY(-120px)' : 'translateY(120px)')) }}>
        {selectedSaw ? (
          sawImage ? (
            <img src={sawImage} alt="Saw" style={{ maxWidth: '100%', maxHeight: '100%' }} />
          ) : (
            <div style={{ width: '5rem', height: '12rem', backgroundColor: '#d1d5db', border: '4px solid #9ca3af', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
              <span style={{ color: 'black', fontWeight: 'bold', fontSize: '0.875rem' }}>NO SAW</span>
            </div>
          )
        ) : (
          <div style={{ width: '5rem', height: '12rem', backgroundColor: '#d1d5db', border: '4px solid #9ca3af', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
            <span style={{ color: 'black', fontWeight: 'bold' }}>Select Saw</span>
          </div>
        )}
      </div>

      <div id="outfeed-modules" ref={outfeedRef} className="contents">
      <BoxComponent
        isGeneratingPdf={isGeneratingPdf}
        boxItems={rightBoxItems}
        boxName="right"
        isRotatedBox={isRotatedBox}
        setIsRotatedBox={setIsRotatedBox}
        checkedItems={checkedItems.right}
        generateConveyorFilename={generateConveyorFilename}
        conveyorStyle={rightBoxConveyorStyle}
        handleCheckboxChange={handleCheckboxChange}
        isReversed={isReversed}
        isFlippedVertically={flippedBoxes.right}
        onBoxItemsChange={handleBoxItemsChange}
        onCheckedItemsChange={handleCheckedItemsChange}
        setActiveBox={setActiveBox}
        motorSelections={motorSelections}
        taSelections={taSelections}
        filenameFlipStates={filenameFlipStates}
        stkSelections={stkSelections}
        globalImageCache={globalImageCache}
        setGlobalImageCache={setGlobalImageCache}
        cacheClearTrigger={rightBoxCacheClear}
        getImageForSelection={getImageForSelection}
        getImageKey={getImageKey}
        leftBoxConveyorStyle={leftBoxConveyorStyle}
        rightBoxConveyorStyle={rightBoxConveyorStyle}
        motorImageUrls={{ left: motorVariantImageUrls.left, right: motorVariantImageUrls.right }}
        taImageUrls={{ left: taImageUrls.left, right: taImageUrls.right }}
        stkImageUrls={{ left: stkImageUrls.left, right: stkImageUrls.right }}
        onMotorSelect={handleMotorSelect}
        motorVariantByBox={motorVariantByBox}
        onDeletePortion={handleDeletePortion}
        sampleData={sampleData}
        setSampleData={setSampleData}
        handleSTKChange={handleSTKChange}
        stkVariantByPortion={stkVariantByPortion}
        handleTAChange={handleTAChange}
        taVariantByPortion={taVariantByPortion}
      />
      </div>

      <FlipButton position="right" onClick={() => handleVerticalFlip('right')} isFlipped={isFlipped} setIsFlipped={setIsFlipped} />
    </div>
  );
};

export default BoxesSection;

